<template>
  <section class="new-team-banner">
    <div class="container">
      <h2 class="banner-heading" v-html="sanitizeHtml(shopifyData.secHeading)" />
      <div class="banner-text-grid">
        <div class="">
          <div>
            <h4 class="banner-text-heading" v-html="sanitizeHtml(shopifyData.leftName)" />
            <p class="banner-text-heading" v-html="sanitizeHtml(shopifyData.leftjobTitle)" />
          </div>

          <p class="banner-text" v-html="sanitizeHtml(shopifyData.leftInfo)" />
        </div>

        <div class="middle-grid-item">&</div>

        <div class="banner_bottom_part">
          <div>
            <h4 class="banner-text-heading" v-html="sanitizeHtml(shopifyData.rightName)" />
            <p class="banner-text-heading" v-html="sanitizeHtml(shopifyData.rightjobTitle)" />
          </div>
          <p class="banner-text" v-html="sanitizeHtml(shopifyData.rightInfo)" />
        </div>
      </div>
    </div>
  </section>
  <div class="only-mob container">
    <div class="bios_container">
      <ul class="bios_list">
        <li class="bios_list-item">
          <h4 class="bios_heading">
            <span v-html="sanitizeHtml(shopifyData.leftName)" />
            <span v-html="sanitizeHtml(shopifyData.leftjobTitle)" />
          </h4>
          <p class="bios_text" v-html="sanitizeHtml(shopifyData.leftInfo)" />
        </li>
        <li class="bios_list-item">
          <h4 class="bios_heading">
            <span v-html="sanitizeHtml(shopifyData.rightName)" />
            <span v-html="sanitizeHtml(shopifyData.rightjobTitle)" />
          </h4>
          <p class="bios_text" v-html="sanitizeHtml(shopifyData.rightInfo)" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    sanitizeHtml,
  },
};
</script>

<style scoped>
.bios_container {
  width: 100%;
  padding: 110px 0 0px;
}

.new-team-banner {
  background-image: url('https://cdn.shopify.com/s/files/1/0689/7618/1550/files/team-banner.png?v=1681298262;');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}

.banner-mobile {
  display: none;
}

.container {
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}

.banner-heading {
  padding-top: 16px;
  font-family: 'Helvetica Neue', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.02em;
  color: #ffffff;
  text-align: center;
}

.banner-text-grid {
  width: 100%;
  display: grid;
  grid-template-columns: 44% 44%;
  justify-content: space-between;
  gap: 40px;
  margin: 0 auto;
  padding: 651px 0 50px;
}

.banner-text-heading {
  font-family: 'Helvetica Neue', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.02em;
  color: #ffffff;
}

.banner-text-heading span {
  display: block;
  width: 100%;
}

.banner-text {
  font-family: 'adobe-caslon-pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  /* color: rgba(255, 255, 255, 1); */
  padding-top: 16px;
  letter-spacing: 0.02em;
  color: #ffffffe3;
}

.banner-text a {
  text-decoration: underline;
  color: #ffffff;
}

.middle-grid-item {
  display: none;
}

@media screen and (max-width: 767px) {
  .banner-text-grid {
    grid-template-columns: 100%;
    padding: 400px 0 90px;
    gap: 50px;
  }

  .banner_bottom_part {
    text-align: end;
  }

  .banner-mobile {
    display: block;
    width: 100%;
  }

  .new-team-banner {
    position: relative;
  }

  .banner-heading {
    position: absolute;
    font-size: 15px;
    top: 15px;
    padding: 0;
    width: auto;
    left: 50%;
    transform: translateX(-50%);
  }

  .banner-text {
    display: none;
  }

  .mob-text-right {
    text-align: right;
  }

  .banner-text-heading {
    font-size: 15px;
    line-height: 18px;
  }

  .middle-grid-item {
    display: block;
    text-align: center;
    padding-top: 16px;
    font-family: 'Helvetica Neue', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    letter-spacing: 0.02em;
    color: #ffffff;
  }
}

.bios_list {
  display: flex;
  flex-direction: column;
  gap: 110px;
}

.bios_list-item {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.only-mob {
  display: none;
}

.bios_heading {
  font-family: 'Helvetica Neue', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #000000;
}

.bios_heading span {
  display: block;
}

.bios_text {
  font-family: 'Adobe Caslon Pro', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #000000;
  letter-spacing: 0.02em;
}

.bios_text a {
  text-decoration: underline;
}

@media screen and (max-width: 767px) {
  .bios_container {
    padding: 24px 0 0px;
  }

  .bios_list {
    gap: 40px;
  }

  .bios_text {
    font-size: 14px;
  }

  .only-mob {
    display: flex;
  }

  .bios_list-item {
    gap: 10px;
  }
}

@media screen and (max-width: 550px) {
  .new-team-banner {
    min-height: 683px;
  }
}
</style>
